<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="d-flex form-heading title-section form-section ">
              <p class="form-title text-center" style="font-size: 15px;">
                Form BR-7
              </p>
              <p class="form-title text-center" style="font-size: 25px;">
                AFFIDAVIT BY ASSURED
              </p>
              <p class="form-title text-center" style="font-size: 15px;">
                Affidavit # 20________
              </p>

            </article>
            <article class="input-section form-section">
              <div >
                <p class="mb-3 ar-sl-disclosure">
                  
                    I/We {{ quote.nameOfPrincipalHomeInspector }} of {{ quote.fullLegalNameOfApplicant }} do hereby state that in
                    {{ formattedCurrentDate() }} I/We directed Isaac Peck my/our
                    Insurance Broker to obtain insurance against certain risks as described herein. My/Our Insurance Broker
                    informed us that the required insurance could not be obtained from, or would not be written by, companies
                    licensed or admitted to transact business in the Commonwealth of Massachusetts.</p>
                <p class="mb-3 ar-sl-disclosure">
                  
                    I/We, the Assured, was/were informed that the type and amount of insurance shown below could be
                    obtained from certain insurers not admitted to transact business in the Commonwealth. I/We was/were
                    further informed:</p>
                <p class="mb-3 ar-sl-disclosure"style="margin-left: 30px">
                  <b>
                  
                    A. The surplus lines insurer with whom the insurance was placed is not licensed in this state and
                    is not subject to Massachusetts regulations.
                  </b></p>
                <p class="mb-3 ar-sl-disclosure"style="margin-left: 30px">
                  <b>
                  
                    B. In the event of the insolvency of the surplus lines insurer, losses will not be paid by the state
                    insurance guaranty fund.</b></p>
                <div class="row mb-2">
                  <div class="col-md-4 form-inline">
                  </div>
                  <div class="col-md-8 form-inline">
                    <p for class="orep-label mb-0 mr-2">
                      Signature by Assured:
                    </p>
                    <input
                      class="orep-text-input notice-input-ma text-center"
                      placeholder="Type Your Name to Sign"
                      name="slDisclosureSignature"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      v-model="quote.slDisclosureSignature"

                    >
                    <span
                      v-show="errors.has('slDisclosureSignature')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('slDisclosureSignature') | filterText }}</span>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-4 form-inline">
                  </div>
                  <div class="col-md-8 form-inline">
                    <p for class="orep-label mb-0 mr-2">
                      Print Name: {{ quote.fullLegalNameOfApplicant }}
                    </p>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-4 form-inline">
                  </div>
                  <div class="col-md-8 form-inline">
                    <p for class="orep-label mb-0 mr-2">
                      Date: {{ formattedCurrentDate() }}
                    </p>
                  </div>
                </div>

                <p class="mb-3 ar-sl-disclosure text-center"style="margin-top: 35px">
                  <b>
                    
                      THIS PORTION MUST BE COMPLETED AND SIGNED BY THE ORIGINAL BROKER</b></p>
                <div class="row">
                  <div class="col-md-6">
                    <section class="mt-3" >
                      <p class="mb-3 ar-sl-disclosure">
                        
                          Name of Insured: <strong> {{ quote.fullLegalNameOfApplicant }}</strong>
                        </p>
                    </section>
                  </div>
                  <div class="col-md-6">
                    <section class="mt-3" >
                    <p class="mb-3 ar-sl-disclosure">
                      Address: <strong>{{ quote.customer.address }}{{ quote.customer.city }},{{ quote.customer.state }},{{ quote.customer.zipCode }}</strong>
                      </p>
                    </section>
                  </div>
                </div>


                <p class="mb-3 ar-sl-disclosure">
                  
                      Location of Property:________________________
                  </p>
                <p class="mb-3 ar-sl-disclosure">
                  
                      Description: ______________________
                  </p>
                <p class="mb-3 ar-sl-disclosure">
                  
                      Coverage: Professional Liability
                  </p>
                <div class="row">
                  <div class="col-md-6">
                    <section>
                      <p class="mb-3 ar-sl-disclosure">
                        
                      Limit: <strong>{{coverages[quote.coverage].limitOfCoverage}}</strong>  </p>
                    </section>
                  </div>
                  <div class="col-md-6">
                    <section>
                      <p class="mb-3 ar-sl-disclosure">
                        Premium: <strong v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberPremium }}</strong>
                          <strong v-else >{{ coverages[quote.coverage].premium }}</strong>
                        </p>
                    </section>
                  </div>
                </div>
                <p class="mb-3 ar-sl-disclosure">
                  
                    A copy of this affidavit must be kept in the original broker's file and a copy must be given to the assured at
                    the time said copy was completed by him/her.</p>
              </div>
            </article>
            <article class="form-heading form-section review-sign input-section">
              <div >
                <p class="mb-3 ar-sl-disclosure" style="margin-top: 25px">
                  I,_________________________________of_________________________________in said county of
                    ______________________depose and say that I was engaged directly by the Assured named herein or
                    informed by the Assured's Insurance licensed Agent/Broker that after diligent efforts, he/she is unable to
                    procure in companies admitted to do business in this Commonwealth the amount and/or type of insurance
                    necessary to protect the insurable interests described above. This Affidavit is made to comply with the
                    requirements of Section 168 of Chapter 175 of the General Laws, and to authorize me as a licensed special
                    insurance broker under said section to procure insurance for said insurable interests beyond that which
                    companies admitted to do business in the Commonwealth are willing to write thereon. The following
                    companies or groups are among those which have accepted all or part thereof:</p>
                <p class="mb-3 ar-sl-disclosure" style="margin-top: 25px">
                  Company  NAIC#  Policy #  Premium
                   </p>
                <p class="mb-3 ar-sl-disclosure" style="margin-top: 25px">
                  Amendments to Affidavit: ( ) Increase ( ) Decrease
                  </p>
                <p class="mb-3 ar-sl-disclosure" style="margin-top: 25px">
                  I hereby verify the foregoing statements and declare that they were made under the penalties of perjury.</p>
                <p class="mb-3 ar-sl-disclosure" style="margin-top: 25px">
                  License # _________________Signature_____________________________Date_______________</p>
                <p class="mb-3 ar-sl-disclosure" style="margin-top: 25px">
                  Original affidavit must be kept in the Special Brokers File and a copy filed with the Division of Insurance
                    of the Commonwealth of Massachusetts within twenty days following date of procurement.</p>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'home-inspector-7'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-2')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-3')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-4')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-5')" v-if="!state.signedInUser"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-6')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-7')"               v-if="quote.applicantOrAssociateHasAnyOtherProfessionalLicense === 'true' && (checkServices('real estate agent') || checkServices('contractor') || checkServices('engineer') || checkServices('pest inspector'))"
              ></button>
              <span class="pagination-dots pagination-current"></span>
            </article>
            <button
              class="next-btn mont spaced text-uppercase"
              @click="formSubmit()"
              :disabled="!state.pageSlDisclosureIsValid"
              :class="{submitDisabled: !state.pageSlDisclosureIsValid}"
            >Submit</button>
          </section>
        </div>
      </div>
    </div>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Processing...</span>
    </div>

  </div>
</template>

<script>
  import $ from "jquery";
  import moment from 'moment';
  import { STATUS } from "../../utils/constants";

  export default {
    name: "home-inspector-6",
    data() {
      return {
        loading: false
      };
    },
    computed: {
      quote() {
        return this.$store.state.homeInspector.quote;
      },
      coverages() {
        return this.$store.state.homeInspector.coverages;
      },
      state() {
        return this.$store.state.homeInspector;
      },
      errorMsg() {
        return this.$store.state.homeInspector.errorMsg;
      }
    },
    watch: {
      errorMsg: {
        handler() {
          if (this.errorMsg) {
            this.loading = false;
            this.$notify({
              group: 'error',
              type: 'error',
              title: 'Error',
              text: this.errorMsg
            });
          }
        }
      }
    },
    methods: {
      navigateToPrev(route) {
        this.$router.push({
          name: route
        });
      },
      next(routeName) {
        this.$router.push({
          name: routeName
        });
      },
      checkServices(service) {
        return this.quote.applicantOrAssociateReportMode.includes(service);
      },
      validateBeforeSubmit() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.state.pageSlDisclosureIsValid = true;
            return;
          }
          this.state.pageSlDisclosureIsValid = false;
        });
      },

      formattedCurrentDate() {
        return moment(this.quote.applicantPrincipleEsignatureDatetime).format('YYYY-MM-DD');
      },
      formSubmit() {
        this.loading = true;
        this.quote.status = STATUS.Submitted;
        this.$store.dispatch('homeInspector/createSlDisclosure');
      }

    },


    filters: {
      filterText(x) {
        if (x !== undefined) {
          if (x.indexOf("req") !== -1) {
            return "This field is required";
          } else {
            return x.replace("_", " ");
          }
        }
      }
    },

    mounted() {
      $('html, body').animate({
        scrollTop: $('.orep-header').offset().top
      }, 500);
    },

    components: {}
  };
</script>

<style scoped>
  strong {
    text-decoration: underline;
  }
  .form-inline > label {
    width: 82px;
    text-align: left;
  }
  .form-heading > p {
    font-size: 35px;
    width: 100%;
    text-align: center;
    margin: 0;
  }
  .form-errors,
  .js-input-errors {
    display: block;
    text-transform: initial;
    font-size: 13px;
    width: 90%;
    margin: auto;
    position: relative;
    top: -29px;
  }
  fieldset {
    font-size: 12px;
  }
  .logo {
    width: 150px;
    height: 45px;
    object-fit: contain;
  }
  h6 {
    font-size: 14px;
  }
  h5 {
    font-size: 16px;
  }
  .company-info-content {
    padding: 10px 30px;
    border: 1px solid black;
  }
  .fs-subtitle {
    margin: 20px 0;
    border-bottom: 2px solid black;
  }
  table.oreptable {
    font-size: 14px;
    margin-left: auto;
    margin-right: auto;
  }
  .gen-inf {
    display: flex;
    background: #eee none repeat scroll 0 0;
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 20px;
    margin-top: 20px;
    padding: 7px;
    text-align: left;
    height: 30px;
    border: 1px solid black;
  }
  .underline-value {
    margin-left: 10px;
    margin-right: 40px;
    border-bottom: 1px solid black;
    margin-bottom: 15px;
    font-weight: 700;
    font-size: 14px;
  }
  .table th, .table td {
    text-align: center;
    vertical-align: middle;
  }
  .table.ar td, .table.ar th {
    border-left: 1px solid #ddd !important;
    border-top: 1px solid #ddd !important;
    border-right: 1px solid #ddd !important;
  }
  .w-20 {
    width: 20%;
  }
  .blank_th {
    width: 210px;
  }
  .footer-company-info {
    background-color: yellow;
    border: 1px solid black;
    padding: 10px 20px 40px;
  }
  .form-check-input {
    position: relative;
    margin-left: 0;
  }
  .page-content p, .page-content li {
    font-size: 15px;
  }
  .p-56, .notice-list > li, .notice-info {
    padding-right: 56px;
  }
</style>

